import { EWeekday } from "@/domain/enums/EWeekday";

// Nomes/ordem espelhando domain/constants/weekdayTypes.ts do app do
// profissional (diag-reactnative).
export const WEEKDAY_LABELS: Record<EWeekday, string> = {
    [EWeekday.MONDAY]: "Segunda-feira",
    [EWeekday.TUESDAY]: "Terça-feira",
    [EWeekday.WEDNESDAY]: "Quarta-feira",
    [EWeekday.THURSDAY]: "Quinta-feira",
    [EWeekday.FRIDAY]: "Sexta-feira",
    [EWeekday.SATURDAY]: "Sábado",
    [EWeekday.SUNDAY]: "Domingo",
};

export const WEEKDAY_ORDER: EWeekday[] = [
    EWeekday.MONDAY,
    EWeekday.TUESDAY,
    EWeekday.WEDNESDAY,
    EWeekday.THURSDAY,
    EWeekday.FRIDAY,
    EWeekday.SATURDAY,
    EWeekday.SUNDAY,
];
